(function ($, Drupal, drupalSettings) {

  Drupal.behaviors.mb_webform = {
    attach: function (context) {

      $('.webform-submission-form').each(function() {

        var dataSiblings = $(this).attr('data-sibling-forms');

        if(dataSiblings !== undefined && dataSiblings !== '') {

          dataSiblings = dataSiblings.replace(/_/g, '-');

          var siblings = dataSiblings.split(',');

          for (var i =0; i < siblings.length; i++) {

            var sibling = $('.webform-submission-' + siblings[i] + '-form');

            if(sibling.length > 0) {

              var mainForm = $(this);

              sibling.find('input').change(function() {

                var mainCopy = mainForm.find("input[data-drupal-selector='" + $(this).attr('data-drupal-selector') + "']");

                if (mainCopy.length > 0) {
                  mainCopy.val($(this).val());
                }

              });

            }
          }

        }

      });

    },
  };

})(jQuery, Drupal, drupalSettings);
